import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { X, Sparkles } from "lucide-react";
import { isIOSApp } from "@/utils/platform";

const HIDE_KEY = "pro_light_promo_hidden_until";

export const ProLightPromoCard = ({ status }) => {
  const navigate = useNavigate();
  const [hidden, setHidden] = useState(() => {
    const until = Number(localStorage.getItem(HIDE_KEY) || 0);
    return until > Date.now();
  });

  const eligible =
    status?.pricing_model === "v2" &&
    !status?.payment_completed &&
    status?.v2_tier === "free" &&
    !isIOSApp();

  if (!eligible || hidden) return null;

  const hide = () => {
    localStorage.setItem(HIDE_KEY, String(Date.now() + 30 * 24 * 60 * 60 * 1000));
    setHidden(true);
  };

  return (
    <Card className="border-amber-200 bg-gradient-to-r from-amber-50 to-white" data-testid="pro-light-promo-card">
      <CardContent className="p-4 sm:p-5">
        <div className="flex flex-col sm:flex-row sm:items-center gap-4">
          <div className="flex items-start gap-3 flex-1 min-w-0">
            <div className="h-9 w-9 rounded-lg bg-amber-100 flex items-center justify-center shrink-0">
              <Sparkles className="h-5 w-5 text-amber-600" />
            </div>
            <div className="text-sm leading-relaxed text-slate-700">
              <p className="font-bold text-slate-900">Pro Light — tutte le funzioni Pro a €4,90/mese</p>
              <p>Residui ferie, report per il consulente, logo, notifiche email, date bloccate e amministrativi. Prezzo fisso fino a 5 dipendenti, disdici quando vuoi.</p>
            </div>
          </div>
          <div className="flex items-center gap-2 shrink-0 self-end sm:self-auto">
            <Button
              onClick={() => navigate("/abbonamento")}
              className="bg-amber-600 hover:bg-amber-700 text-white"
              data-testid="pro-light-promo-cta"
            >
              Scopri Pro Light
            </Button>
            <button
              type="button"
              onClick={hide}
              aria-label="Chiudi"
              className="p-2 rounded-md text-slate-400 hover:text-slate-600 hover:bg-slate-100"
              data-testid="pro-light-promo-dismiss"
            >
              <X className="h-4 w-4" />
            </button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
